import cx from 'classnames';
import React from 'react';
import { IconID } from '../../icon';
import { ChipBase } from '../chip-base/chip-base';
import styles from '../chip-base/chip-base.module.scss';
export const ChipTrigger = ({ options = [], className, containerClassName, type = 'filter', onClose, onClick, wrap = false, ...restProps }) => {
    const classNames = cx(className, {
        [styles.splitTrigger]: options.length,
        [styles.wrapChips]: wrap,
    });
    const getIcon = () => {
        return type === 'skeleton' ||
            type === 'filter' ||
            type === 'adhocAttribute' ||
            !onClick
            ? undefined
            : IconID.CHEVRON_RIGHT;
    };
    return (React.createElement(ChipBase, { className: classNames, containerClassName: containerClassName, size: "m", type: type, options: options, variant: "trigger", icon: getIcon(), onClose: options.length || ['suggestion', 'skeleton'].includes(type)
            ? undefined
            : onClose, onClick: onClick, ...restProps }));
};
//# sourceMappingURL=chip-trigger.js.map